import { useTranslation } from 'react-i18next';
import { Controller, type UseFormReturn } from 'react-hook-form';
import { Input } from '@/shared/ui/inputs/Input';
import { FeaturesProfileLanguagesInput } from '@/features/profile/modules/ui/LanguagesInput';
import type { ProfileFormValues } from '@/features/profile/modules/types';

type Props = {
  form: UseFormReturn<ProfileFormValues>;
  email: string;
  onSubmit: (values: ProfileFormValues) => void;
  id?: string;
};

export const FeaturesProfileProfileForm = ({ form, email, onSubmit, id }: Props) => {
  const { t } = useTranslation('profile');
  const { register, control, formState, handleSubmit } = form;
  const errors = formState.errors;

  return (
    <form id={id} onSubmit={handleSubmit(onSubmit)} className="flex flex-col gap-3">
      <Input label={t('fields.email')} value={email} readOnly disabled />
      <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
        <Input
          label={t('fields.firstName')}
          error={errors.first_name?.message ? t(errors.first_name.message) : undefined}
          {...register('first_name')}
        />
        <Input
          label={t('fields.lastName')}
          error={errors.last_name?.message ? t(errors.last_name.message) : undefined}
          {...register('last_name')}
        />
      </div>
      <Input
        label={t('fields.phone')}
        placeholder="+998901234567"
        error={errors.phone_number?.message ? t(errors.phone_number.message) : undefined}
        {...register('phone_number')}
      />
      <Controller
        control={control}
        name="languages"
        render={({ field }) => (
          <FeaturesProfileLanguagesInput value={field.value} onChange={field.onChange} />
        )}
      />
    </form>
  );
};
